var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkActivityReject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.7411 133.339H65.8203C58.3516 133.339 54.6182 133.339 52.2974 130.974C49.9766 128.609 49.9766 124.803 49.9766 117.193C49.9766 109.582 49.9766 105.776 52.2974 103.411C54.6182 101.047 58.3516 101.047 65.8203 101.047H73.7432C81.212 101.047 84.9474 101.047 87.2682 103.411C89.0536 105.23 89.4641 107.903 89.5599 112.505",
    stroke: "#495057",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0781 128.87L82.2656 126.995V122.307M79.1406 101.057L78.9323 100.411C77.9031 97.2031 77.3865 95.599 76.1594 94.6823C74.9302 93.7656 73.301 93.7656 70.0406 93.7656H69.4906C66.2302 93.7656 64.599 93.7656 63.3719 94.6823C62.1427 95.599 61.6281 97.2031 60.5969 100.411L60.3906 101.057M72.8906 126.057C72.8906 127.288 73.1331 128.508 73.6043 129.645C74.0754 130.782 74.7659 131.816 75.6365 132.686C76.507 133.557 77.5405 134.248 78.678 134.719C79.8154 135.19 81.0345 135.432 82.2656 135.432C83.4968 135.432 84.7159 135.19 85.8533 134.719C86.9907 134.248 88.0242 133.557 88.8947 132.686C89.7653 131.816 90.4559 130.782 90.927 129.645C91.3981 128.508 91.6406 127.288 91.6406 126.057C91.6406 123.571 90.6529 121.186 88.8947 119.428C87.1366 117.67 84.752 116.682 82.2656 116.682C79.7792 116.682 77.3947 117.67 75.6365 119.428C73.8783 121.186 72.8906 123.571 72.8906 126.057Z",
    stroke: "#495057",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1832 70.5H45.5C42.7386 70.5 40.5 68.2615 40.5 65.5V15.5C40.5 12.7386 42.7386 10.5 45.5 10.5H95.5C98.2615 10.5 100.5 12.7386 100.5 15.5V32.2173",
    stroke: "#7663EB",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.496 48.9062V68.8486C100.496 69.7691 99.7495 70.5152 98.829 70.5152H78.8906",
    stroke: "#7663EB",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 48.9062H60.5",
    stroke: "#7663EB",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8281 38.8438L58.8281 48.8437L68.8281 58.8437",
    stroke: "#7663EB",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkActivityReject);
export default __webpack_public_path__ + "static/media/work-activity-reject.cce5a9194a8eeca7cd1727c8a820c0ae.svg";
export { ForwardRef as ReactComponent };